<div class="db-card">
    <div class="db-card__head-row">
        <div class="db-thunder-stage" aria-hidden="true">
            <div class="db-thunder-particle" *ngFor="let p of particles" [style.--dx]="p[0] + 'px'"
                [style.--dy]="p[1] + 'px'"></div>
            <div class="db-thunder-icon-wrap">
                <img *ngIf="icon; else iconFontTpl" [src]="icon" alt="">
                <ng-template #iconFontTpl>
                    <span class="db-card__icon db-card__icon--font"><i [class]="iconClass"></i></span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="db-card__text-group">
        <div class="db-card__value" *ngIf="!custom" [ngClass]="valueClass">
            {{ parts.value }} <span class="db-card__unit" *ngIf="parts.unit">{{ parts.unit }}</span>
        </div>
        <div class="db-card__custom" *ngIf="custom">
            <ng-content></ng-content>
        </div>
        <div class="db-card__label">{{ label }}</div>
    </div>
</div>
